import { __rest } from "tslib";
import React from 'react';
import { ListItemView } from '../../useList';
import { block } from '../../utils/cn';
import './TreeSelectItem.css';
const b = block('tree-select-item');
export const TreeSelectItem = React.forwardRef(function TreeSelectItem(_a, ref) {
    var { as = 'div', className, wrapperClassName } = _a, props = __rest(_a, ["as", "className", "wrapperClassName"]);
    const Tag = as;
    return (React.createElement(Tag, { ref: ref, className: b(null, wrapperClassName) },
        React.createElement(ListItemView, Object.assign({ as: as }, props, { className: className }))));
});
